import { animate, state, style, transition, trigger } from '@angular/animations';
import { Component, ElementRef, HostListener, OnInit, ViewChild } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { NavigationEnd, Router } from '@angular/router';
import { CommonDataService } from 'src/app/common/services/common-data.service';
import { GraphqlService } from 'src/app/common/services/graphql.service';
import { LoginService } from '../../common/services/Login.service';
import { SearchInput } from '../../common/models/SearchInput';
import { HttpcallService } from 'src/app/common/services/httpcall.service';
import { forkJoin, Subject, Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged, filter } from 'rxjs/operators';
import { SessionService } from '../../common/services/Session.service';
import { ConfirmDialogComponent } from '../../common/shared-components/confirm-dialog/confirm-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { constObj } from '../../common/Constants/constants';
import { Location } from '@angular/common';

@Component({
  selector: 'app-left-side-menu',
  templateUrl: './left-side-menu.component.html',
  styleUrls: ['./left-side-menu.component.css'],
  animations: [
    trigger('slideInOut', [
      state('in', style({
        transform: 'translate3d(0,0,0)',
        opacity: 1,
      })),
      state('out', style({
        transform: 'translate3d(-10%,0,0)',
        opacity: 0,
        // zIndex : 1
      })),
      transition('in => out', animate('400ms ease-in-out')),
      transition('out => in', animate('400ms ease-in-out')),
    ])
  ]
})
export class LeftSideMenuComponent implements OnInit {
  logo: any;
  searchInput: SearchInput = new SearchInput();
  logoutURL: any;
  pdfBackup: boolean = false;
  @HostListener('document:keydown', ['$event']) onKeyPress(event: KeyboardEvent) {
    if (event.key === "Escape") {
      this.closeNav();
    }
  }

  @ViewChild("navLevel1") elemLevel1: ElementRef;
  @ViewChild("navLevel2") elemLevel2: ElementRef;
  @ViewChild("navLevel3") elemLevel3: ElementRef;
  @ViewChild("navLevel4") elemLevel4: ElementRef;
  @ViewChild("navLevel5") elemLevel5: ElementRef;
  constructor(
    private route: Router,
    private commonDataService: CommonDataService,
    private graphqlService: GraphqlService,
    private _loginservice: LoginService,
    private domSanitizer: DomSanitizer,
    private httpCall: HttpcallService,
    private session: SessionService,
    public dialog: MatDialog,
    private location: Location,
    private loginService: LoginService,
  ) {
    if (this.route.url.includes("GARSpdfs")) { this.pdfBackup = true; } else {
      this.pdfBackup = false;
      if (this.session.userInfo == undefined || this.session.userInfo.user == null) {
        this.loginService.getSession().subscribe(data => {
          if (data.user != null) {
            this.mailId = data.user.email;
            this.role = data.user.roles;
            this.session.assignUserInfo(data.user);
          }
          else { this.route.navigateByUrl("/Login"); }
        });
      }
      else {
        this.mailId = this.session.userInfo.user.email;
        this.role = this.session.userInfo.user.roles;
      }
      if (this.route.url?.includes("/Login?u")) { this.route.navigateByUrl(window.location.origin); }
    }
  }
  searchtext;
  showButton;
  enterText;
  text;
  hereExample;
  example1;
  example2;
  searchText;
  implementationGuide;
  originalPronouncements;
  codification;
  othersHeader;
  topResults;
  originalIndex: number;
  selectedIndexLevel1: number;
  selectedIndexLevel2: number;
  selectedIndexLevel3: number;
  selectedIndexLevel4: number;
  selectedIndexLevel5: number;
  menuOpen: boolean = false;
  flag: boolean;
  tempData: any;
  searchLabel: string = ""
  searchIcon: string = ""
  searchLink: string = ""
  l2State: string = "out"
  l3State: string = "out"
  l4State: string = "out"
  l5State: string = "out"
  btnState: string = "out";
  crumbData = []
  crumbDataNav = []
  isArchive: boolean = true;
  menuIndexNegativeArr = [
    true,
    true,
    true,
    true
  ]
  apiResponse;
  navPanelData;
  navigationLabels = {};
  urlPath: string = "";
  userId: string = "";
  role: string = "";
  mailId: string = "";
  isCurrentLeftNav: boolean = true;
  isSearchClicked: boolean = false;
  top5CodRecords;
  top5OpRecords;
  top5CigRecords;
  autoSuggestion;
  autoSuggestedOptionLength: number = 0;
  numberOfResult: number = 0;
  CodGlossaryResult = [];
  OpGlossaryResult = [];
  CigGlossaryResult = [];
  annotationResult;
  bookmarkResult;
  private searchSub$ = new Subject<string>();
  leftNavmenuLevel = [0, 1, 2];
  searchTabHeading: any = [];
  event$: Subscription;
  ngOnInit(): void {
    this.commonDataService.openSearchFromOutSide.subscribe(() => {
      this.triggerSearchFromOutSide();
    });
    if (this.route.url.includes("GARSpdfs")) {
      this.pdfBackup = true;
      this.loadLogo(); this.outcome = true;
    }
    else {
      this.pdfBackup = false;
      this.searchSub$.pipe(
        debounceTime(100),
        distinctUntilChanged()
      ).subscribe((filterValue: string) => {
        if (filterValue.replace(/\*/gi, "").trim() != "") {
          this.onSearchChange(filterValue);
        }
      });

      let rawLeftNavigation: any = JSON.parse(localStorage.getItem("rawLeftNavigationMenu"));
      if (rawLeftNavigation != undefined) {
        let publicationId = rawLeftNavigation[1].itemData[0].itemData[0].itemData[0].itemLink.split('/');
        localStorage.setItem("currentVersionPublicationId", publicationId[0]);
        localStorage.setItem("publicationId", publicationId[0]);
        this.getLeftNavigation(rawLeftNavigation);
        this.isArchive = false;
        this.outcome = true;
      }
      else {
        if (localStorage.getItem("publicationId") != undefined && localStorage.getItem("currentVersionPublicationId") != localStorage.getItem("publicationId")) {
          this.graphqlService.getArchiveLeftNavigation(localStorage.getItem("publicationId")).subscribe(leftNavigationData => {
            this.getLeftNavigation(leftNavigationData);
            this.tempData = this.tempData.filter(x => x.item != "My GARS" && x.item != "Search" && x.item != "Other Reference");
            this.tempData[this.tempData.length - 4].spaceOnTop = "true";
            this.tempData[this.tempData.length - 4].itemData = this.tempData[this.tempData.length - 4].itemData.filter(x => x.item != "Search" && x.item != "Source Tracing Tool" && x.item != "Glossary Term Finder");
            this.isArchive = true;
            this.commonDataService.showLoader.next(false);
            this.outcome = true;
          });
        }
        else {
          this.graphqlService.getCurrentVersionLeftNavigation().subscribe(leftNavigationData => {
            //this.graphqlService.getLeftNavigation().subscribe(leftNavigationData => {
            this.getLeftNavigation(leftNavigationData);
            this.isArchive = false;
            this.outcome = true;
          });
        }
      }
      this.loadLogo();


      this.event$
        = this.route.events
          ?.pipe(
            filter(event => event instanceof NavigationEnd)
          )
          .subscribe(() => {
            if (this.route.url.split("/")[1].split("-").length > 2) {
              this.getBreadcrumbForNav(this.route.url.split("/")[1].split("-")[0]);
              this.isSearchClicked = false;
            }
            else if (this.route.url.includes("showallinonepage")) {
              this.getBreadcrumbForNav(this.route.url.split("/")[1]);
              this.isSearchClicked = false;
            }
            else if (!this.route.url.includes("showallinonepage")) {
              let urlParts = this.route.url.split("/");
              if (urlParts.length > 2) {
                this.getBreadcrumbWithRouteUrl(urlParts[1] + "/" + urlParts[2]);
                this.isSearchClicked = false;
              }
              else if (this.route.url.includes("Home")) {
                this.isSearchClicked = false;
                this.area = '';
                this.selectedIndexLevel1 = undefined;
              }
              else if (this.route.url.includes("MyHistory") || this.route.url.includes("myAnnotations") || this.route.url.includes("myBookmarks") || this.route.url.includes("RedisCacheManagement") || this.route.url.includes("AccessManagement")) {
                this.isSearchClicked = false;
                this.area = "My GARS";
              }
              else if (this.route.url.includes("sourcetracingtool") || this.route.url.includes("GlossaryTermFinder") || this.route.url.includes("help")) {
                this.isSearchClicked = false;
                this.area = "Tools";
              }
              else if (this.route.url.includes("finalpronouncements")) {
                this.isSearchClicked = false;
                this.area = "Other Sources";
              }
              else if (this.route.url.includes("search")) {
                this.isSearchClicked = true;
                this.area = "";
                this.selectedIndexLevel1 = 100;
              }
              else {
                this.isSearchClicked = false;
                this.area = "";
                this.selectedIndexLevel1 = undefined;
              }
            } else {
              this.isSearchClicked = false;
              this.area = "";
              this.selectedIndexLevel1 = undefined;
            }

            this.commonDataService.loadCurrentLeftNav.subscribe(data => {
              if (data != null && data != "" && (!this.isCurrentLeftNav)) {
                if (data == localStorage.getItem("currentVersionPublicationId")) {
                  this.isCurrentLeftNav = true;
                  this.commonDataService.showLoader.next(true);
                  this.graphqlService.getCurrentVersionLeftNavigation().subscribe(leftNavigationData => {
                    //this.graphqlService.getLeftNavigation().subscribe(leftNavigationData => {
                    let publicationId = leftNavigationData[1].itemData[0].itemData[0].itemData[0].itemLink.split('/');
                    localStorage.setItem("currentVersionPublicationId", publicationId[0]);
                    localStorage.setItem("publicationId", publicationId[0]);
                    this.getLeftNavigation(leftNavigationData);
                    this.commonDataService.showLoader.next(false);
                    this.isArchive = false;
                    this.outcome = true;
                  });
                }
                else {
                  this.graphqlService.getArchiveLeftNavigation(data).subscribe(leftNavigationData => {
                    this.isCurrentLeftNav = false;
                    localStorage.setItem("publicationId", data);
                    this.getLeftNavigation(leftNavigationData);
                    this.tempData = this.tempData.filter(x => x.item != "My GARS" && x.item != "Search" && x.item != "Other Reference");
                    this.tempData[this.tempData.length - 4].spaceOnTop = "true";
                    this.tempData[this.tempData.length - 4].itemData = this.tempData[this.tempData.length - 4].itemData.filter(x => x.item != "Search" && x.item != "Source Tracing Tool" && x.item != "Glossary Term Finder");
                    this.isArchive = true;
                    this.getArchiveVersion(data, this.tempData[this.tempData.length - 3].itemData);
                    this.commonDataService.showLoader.next(false);
                    this.outcome = true;
                  });
                }
              }
            });
            //if (!url.includes("showallinonepage")) {
            //  let urlParts = url.split("/");
            //  if (urlParts.length > 2) {
            //    this.getBreadcrumbWithRouteUrl(urlParts[1] + "/" + urlParts[2]);
            //  } else {
            //    this.getBreadcrumbWithRouteUrl(url.substring(1));
            //  }
            //} else if (url.includes("showallinonepage")) {
            //  this.getBreadcrumbForNav(url.split("/")[1]);
            //}
          });
    }
  }
  triggerSearchFromOutSide() {
    this.selectedIndexLevel1 = 100;
    this.isSearchClicked = true;
    this.highlight = undefined;
    this.popupRedirect(1, 2);
  }
  getArchiveVersion(publicationId, data)
  {
    for (let i = 0; i < data.length; i++) {
      if (data[i].itemLink == publicationId) {
        localStorage.setItem("ArchiveVersion", data[i].item);
      }
    }
  }

  outcome: boolean = false;
  getLeftNavigation(data) {
    this.tempData = data;
    for (let obj of this.tempData.slice(1)) {
      this.addshowallinonecondition(obj);

    }
    this.searchLabel = this.tempData[0].item;
    this.searchIcon = this.tempData[0].logoSrc;
    this.searchLink = this.tempData[0].itemLink;
    this.tempData = this.tempData.filter(x => x.item != this.searchLabel);
    this.tempData[this.tempData.length - 2].logoSrc = this.domSanitizer.bypassSecurityTrustUrl(this.tempData[this.tempData.length - 2].logoSrc);
    if (localStorage.getItem("currentVersionPublicationId") != undefined && localStorage.getItem("currentVersionPublicationId") == localStorage.getItem("publicationId")) {
      this.tempData[this.tempData.length - 3].logoSrc = this.domSanitizer.bypassSecurityTrustUrl(this.tempData[this.tempData.length - 3].logoSrc);
    }
    if (this.session.userInfo == undefined || this.session.userInfo.user == null) {
      this._loginservice.getSession().subscribe(data1 => {
        this.applyFilterOnNavigation(data1);
      }, error => {
        console.log('Left-nav', error)
        this.route.navigateByUrl("/Login")
      })
    }
    else {
      this.applyFilterOnNavigation(this.session.userInfo);
    }

    this.area = "";
    let url = this.route.url;
    if (!url.includes("showallinonepage")) {
      let urlParts = url.split("/");
      if (urlParts.length > 2) {
        this.getBreadcrumbWithRouteUrl(urlParts[1] + "/" + urlParts[2]);
      } else {
        this.getBreadcrumbWithRouteUrl(url.substring(1));
      }
    } else if (url.includes("showallinonepage")) {
      this.getBreadcrumbForNav(url.split("/")[1]);
    }
  }

  applyFilterOnNavigation(data1) {
    this.userId = data1.user.userName;
    this.role = data1.user.roles;
    this.mailId = data1.user.email;
    this.tempData[this.tempData.length - 5].itemData = this.tempData[this.tempData.length - 5].itemData.filter(x => x.item != "GASB Maintenance History");

    if (data1.user.roles == "Basic") {
      this.tempData = this.tempData.filter(x => x.item != "My GARS");
      //this.tempData = this.tempData.filter(x => x.item != "Search/Go To");
      //this.tempData = this.tempData.filter(x => x.item != "Other Reference");
      //this.tempData[this.tempData.length - 2].itemData = this.tempData[this.tempData.length - 2].itemData.filter(x => x.item != "My Account Details" && x.item != "My History" && x.item != "My Annotations" && x.item != "My Subscription Information" && x.item != "Current Activity" && x.item != "My Bookmarks");
      //this.tempData[this.tempData.length - 4].itemData = this.tempData[this.tempData.length - 4].itemData.filter(x => x.item != "Pending Content System");/* && x.item != "Search" && x.item != "Source Tracing Tool" && x.item != "Glossary Term Finder");*/
      //this.tempData[this.tempData.length - 4].itemData = this.tempData[this.tempData.length - 4].itemData.filter(x => x.item != "Effective Dates and Certain Transition Provisions");
    }

    else if (data1.user.roles == "Academic") {
      //this.tempData = this.tempData.filter(x => x.item != "My GARS");
      this.tempData[this.tempData.length - 3].itemData = this.tempData[this.tempData.length - 3].itemData.filter(x => x.item != "My Annotations" && x.item != "My History" && x.item != "My Bookmarks");
    }
    else {
      if (!data1.user.isAdmin) {
        this.tempData[this.tempData.length - 3].itemData = this.tempData[this.tempData.length - 3].itemData.filter(x => x.item != "Access Management");
        this.tempData[this.tempData.length - 3].itemData = this.tempData[this.tempData.length - 3].itemData.filter(x => x.item != "Redis Cache Management");
      }
    }
    localStorage.removeItem("rawLeftNavigationMenu");
    this.getMiniLeftNav(this.tempData);
  }

  getMiniLeftNav(leftNavigation) {
    let miniLeftNav: any[] = [];
    for (let i = 0; i < leftNavigation.length; i++) {
      let miniLeftNavLevel1: any = {};
      miniLeftNavLevel1.guid = leftNavigation[i].guid;
      miniLeftNavLevel1.item = leftNavigation[i].item;
      miniLeftNavLevel1.itemLink = leftNavigation[i].itemLink;
      miniLeftNavLevel1.navPath = leftNavigation[i].navPath;
      miniLeftNavLevel1.rollUp = leftNavigation[i].rollUp;
      miniLeftNavLevel1.archiveListGuids = leftNavigation[i].archiveListGuids;
      miniLeftNavLevel1.afterShowAllInOnePageRequired = leftNavigation[i].afterShowAllInOnePageRequired;
      if (leftNavigation[i].itemData != null) {
        let leftNavLevel2 = [];
        for (let j = 0; j < leftNavigation[i].itemData.length; j++) {
          let miniLeftNavLevel2: any = {};
          miniLeftNavLevel2.guid = leftNavigation[i].itemData[j].guid;
          miniLeftNavLevel2.item = leftNavigation[i].itemData[j].item;
          miniLeftNavLevel2.itemLink = leftNavigation[i].itemData[j].itemLink;
          miniLeftNavLevel2.navPath = leftNavigation[i].itemData[j].navPath;
          miniLeftNavLevel2.rollUp = leftNavigation[i].itemData[j].rollUp;
          miniLeftNavLevel2.archiveListGuids = leftNavigation[i].itemData[j].archiveListGuids;
          miniLeftNavLevel2.afterShowAllInOnePageRequired = leftNavigation[i].itemData[j].afterShowAllInOnePageRequired;
          if (leftNavigation[i].itemData[j].itemData != null) {
            let leftNavLevel3 = [];
            for (let k = 0; k < leftNavigation[i].itemData[j].itemData.length; k++) {
              let miniLeftNavLevel3: any = {};
              miniLeftNavLevel3.guid = leftNavigation[i].itemData[j].itemData[k].guid;
              miniLeftNavLevel3.item = leftNavigation[i].itemData[j].itemData[k].item;
              miniLeftNavLevel3.itemLink = leftNavigation[i].itemData[j].itemData[k].itemLink;
              miniLeftNavLevel3.navPath = leftNavigation[i].itemData[j].itemData[k].navPath;
              miniLeftNavLevel3.rollUp = leftNavigation[i].itemData[j].itemData[k].rollUp;
              miniLeftNavLevel3.archiveListGuids = leftNavigation[i].itemData[j].itemData[k].archiveListGuids;
              miniLeftNavLevel3.afterShowAllInOnePageRequired = leftNavigation[i].itemData[j].itemData[k].afterShowAllInOnePageRequired;
              if (leftNavigation[i].itemData[j].itemData[k].itemData != null) {
                let leftNavLevel4 = [];
                for (let m = 0; m < leftNavigation[i].itemData[j].itemData[k].itemData.length; m++) {
                  let miniLeftNavLevel4: any = {};
                  miniLeftNavLevel4.guid = leftNavigation[i].itemData[j].itemData[k].itemData[m].guid;
                  miniLeftNavLevel4.item = leftNavigation[i].itemData[j].itemData[k].itemData[m].item;
                  miniLeftNavLevel4.itemLink = leftNavigation[i].itemData[j].itemData[k].itemData[m].itemLink;
                  miniLeftNavLevel4.navPath = leftNavigation[i].itemData[j].itemData[k].itemData[m].navPath;
                  miniLeftNavLevel4.rollUp = leftNavigation[i].itemData[j].itemData[k].itemData[m].rollUp;
                  miniLeftNavLevel4.archiveListGuids = leftNavigation[i].itemData[j].itemData[k].itemData[m].archiveListGuids;
                  miniLeftNavLevel4.afterShowAllInOnePageRequired = leftNavigation[i].itemData[j].itemData[k].itemData[m].afterShowAllInOnePageRequired;
                  if (leftNavigation[i].itemData[j].itemData[k].itemData[m].itemData != null) {
                    let leftNavLevel5 = [];
                    for (let n = 0; n < leftNavigation[i].itemData[j].itemData[k].itemData[m].itemData.length; n++) {
                      let miniLeftNavLevel5: any = {};
                      miniLeftNavLevel5.guid = leftNavigation[i].itemData[j].itemData[k].itemData[m].itemData[n].guid;
                      miniLeftNavLevel5.item = leftNavigation[i].itemData[j].itemData[k].itemData[m].itemData[n].item;
                      miniLeftNavLevel5.itemLink = leftNavigation[i].itemData[j].itemData[k].itemData[m].itemData[n].itemLink;
                      miniLeftNavLevel5.navPath = leftNavigation[i].itemData[j].itemData[k].itemData[m].itemData[n].navPath;
                      miniLeftNavLevel5.rollUp = leftNavigation[i].itemData[j].itemData[k].itemData[m].itemData[n].rollUp;
                      miniLeftNavLevel5.archiveListGuids = leftNavigation[i].itemData[j].itemData[k].itemData[m].itemData[n].archiveListGuids;
                      miniLeftNavLevel5.afterShowAllInOnePageRequired = leftNavigation[i].itemData[j].itemData[k].itemData[m].itemData[n].afterShowAllInOnePageRequired;
                      if (leftNavigation[i].itemData[j].itemData[k].itemData[m].itemData[n].itemData != null) {
                        let leftNavLevel6 = [];
                        for (let o = 0; o < leftNavigation[i].itemData[j].itemData[k].itemData[m].itemData[n].itemData.length; o++) {
                          let miniLeftNavLevel6: any = {};
                          miniLeftNavLevel6.guid = leftNavigation[i].itemData[j].itemData[k].itemData[m].itemData[n].itemData[o].guid;
                          miniLeftNavLevel6.item = leftNavigation[i].itemData[j].itemData[k].itemData[m].itemData[n].itemData[o].item;
                          miniLeftNavLevel6.itemLink = leftNavigation[i].itemData[j].itemData[k].itemData[m].itemData[n].itemData[o].itemLink;
                          miniLeftNavLevel6.navPath = leftNavigation[i].itemData[j].itemData[k].itemData[m].itemData[n].itemData[o].navPath;
                          miniLeftNavLevel6.rollUp = leftNavigation[i].itemData[j].itemData[k].itemData[m].itemData[n].itemData[o].rollUp;
                          miniLeftNavLevel6.archiveListGuids = leftNavigation[i].itemData[j].itemData[k].itemData[m].itemData[n].itemData[o].archiveListGuids;
                          miniLeftNavLevel6.afterShowAllInOnePageRequired = leftNavigation[i].itemData[j].itemData[k].itemData[m].itemData[n].itemData[o].afterShowAllInOnePageRequired;
                          if (leftNavigation[i].itemData[j].itemData[k].itemData[m].itemData[n].itemData[o].itemData != null) {
                            let leftNavLevel7 = [];
                            for (let p = 0; p < leftNavigation[i].itemData[j].itemData[k].itemData[m].itemData[n].itemData[o].itemData.length; p++) {
                              let miniLeftNavLevel7: any = {};
                              miniLeftNavLevel7.guid = leftNavigation[i].itemData[j].itemData[k].itemData[m].itemData[n].itemData[o].itemData[p].guid;
                              miniLeftNavLevel7.item = leftNavigation[i].itemData[j].itemData[k].itemData[m].itemData[n].itemData[o].itemData[p].item;
                              miniLeftNavLevel7.itemLink = leftNavigation[i].itemData[j].itemData[k].itemData[m].itemData[n].itemData[o].itemData[p].itemLink;
                              miniLeftNavLevel7.navPath = leftNavigation[i].itemData[j].itemData[k].itemData[m].itemData[n].itemData[o].itemData[p].navPath;
                              miniLeftNavLevel7.rollUp = leftNavigation[i].itemData[j].itemData[k].itemData[m].itemData[n].itemData[o].itemData[p].rollUp;
                              miniLeftNavLevel7.archiveListGuids = leftNavigation[i].itemData[j].itemData[k].itemData[m].itemData[n].itemData[o].itemData[p].archiveListGuids;
                              miniLeftNavLevel7.afterShowAllInOnePageRequired = leftNavigation[i].itemData[j].itemData[k].itemData[m].itemData[n].itemData[o].itemData[p].afterShowAllInOnePageRequired;
                              leftNavLevel7.push(miniLeftNavLevel7);
                            }
                            miniLeftNavLevel6.itemData = leftNavLevel7;
                          }
                          leftNavLevel6.push(miniLeftNavLevel6);
                        }
                        miniLeftNavLevel5.itemData = leftNavLevel6;
                      }
                      leftNavLevel5.push(miniLeftNavLevel5);
                    }
                    miniLeftNavLevel4.itemData = leftNavLevel5;
                  }
                  leftNavLevel4.push(miniLeftNavLevel4);
                }
                miniLeftNavLevel3.itemData = leftNavLevel4;
              }
              leftNavLevel3.push(miniLeftNavLevel3);
            }
            miniLeftNavLevel2.itemData = leftNavLevel3;
          }
          leftNavLevel2.push(miniLeftNavLevel2);
        }
        miniLeftNavLevel1.itemData = leftNavLevel2;
      }
      miniLeftNav.push(miniLeftNavLevel1);
    }
    localStorage.setItem("leftNavigationMenu", JSON.stringify(miniLeftNav));
  }

  applyFilter(filterValue: string) {
    this.searchSub$.next(filterValue.replace(/[^a-zA-Z0-9 \.\/\'\"*\-()]/g, " "))
  }
  lastlevelreached: boolean = false;
  rollup: any;
  addshowallinonecondition(obj) {

    for (let items of obj?.itemData) {
      if (items?.itemData?.length > 0) {
        this.addshowallinonecondition(items);
      }
      if (items?.itemData?.length == 0) {
        items.showallinpagerequired = true;
      }
      if (items?.itemData?.length > 0 && this.checkchildnodes(items)) {
        items.showallinpagerequired = true;
      }
    }
  }

  checkchildnodes(items): boolean {
    for (let item of items?.itemData) {
      this.rollup = items.rollUp;
      if (item?.itemData?.length > 0 && this.rollup != "False") {
        for (let inneritem of item?.itemData) {
          if ((inneritem.showallinpagerequired == false || inneritem.itemData?.length > 0)) {
            return false;
          }
        }
      } else {
        if (item.showallinpagerequired == false && item.rollUp == "true") {
          return false;
        }
      }

    }
    return true;
  }
  redirectToUrl(source, glossaryType) {
    let crumbData;
    let obj;

    let url = "/" + source.publicationid + "/" + source.topicId + "/" + source.paraId;
    this.route.navigateByUrl(url);
    this.closeNav();
  }

  suggestedValue(value) {
    this.onSearchChange(value);
  }

  search() {

    //var slides = document.getElementsByClassName('selectedFirstNavElement');
    //for (var i = 0; i < slides.length; i++) {
    //  slides[i].classList.remove('selectedFirstNavElement')
    //}
    //document.getElementsByClassName('search-margin')[0]?.classList.add('selectedFirstNavElement');

    this.crumbData = [];
    this.l2State = "in";
    this.l3State = "out";
    this.l4State = "out";
    this.l5State = "out";
    this.selectedIndexLevel2 = undefined;
    this.selectedIndexLevel3 = undefined;
    this.selectedIndexLevel4 = undefined;
    this.selectedIndexLevel5 = undefined;
    this.btnState = "in";
    this.flag = true;

    this.searchText = "";
    this.searchInput.inputText = "";
    this.searchTabHeading = [];

    this.graphqlService.getSearchLabels().subscribe(data => {
      if (data != "") {
        var labels = data.content.data.labels;
        labels = labels.filter(x => x.key.trim());
        this.showButton = labels.filter(x => x.key == "search_showResultsText").map(y => y.value);
        this.searchtext = labels.filter(x => x.key == "search_searchGarsFor").map(y => y.value);
        this.enterText = labels.filter(x => x.key == "search_EnterText").map(y => y.value);
        this.text = labels.filter(x => x.key == "search_instruction").map(y => y.value);
        this.hereExample = labels.filter(x => x.key == "search_HereExample").map(y => y.value);
        this.example1 = labels.filter(x => x.key == "search_Example1").map(y => y.value);
        this.example2 = labels.filter(x => x.key == "search_Example2").map(y => y.value);
        this.originalPronouncements = labels.filter(x => x.key == "search_originalPronouncements").map(y => y.value);
        this.codification = labels.filter(x => x.key == "search_codification").map(y => y.value);
        this.implementationGuide = labels.filter(x => x.key == "search_implementationGuide").map(y => y.value);
        this.othersHeader = labels.filter(x => x.key == "search_otherText").map(y => y.value);
        this.topResults = labels.filter(x => x.key == "search_TopResults").map(y => y.value);
        var tabHeading = this.tempData.filter((el, i) => this.leftNavmenuLevel.some(j => i === j)).map(y => y.item);
        tabHeading.forEach(columnLabels => {
          if (columnLabels.toLocaleLowerCase().includes(("Codification").toLocaleLowerCase()) || columnLabels.toLocaleLowerCase().includes(("Original Pronouncements").toLocaleLowerCase()) || columnLabels.toLocaleLowerCase().includes(("Comprehensive Implementation Guide").toLocaleLowerCase())) {
            this.searchTabHeading.push(columnLabels);
          }
        })
        if (this.searchTabHeading.length != 3) {
          if (!this.searchTabHeading.some(x => x.toLocaleLowerCase().includes(("Codification").toLocaleLowerCase()))) {
            this.searchTabHeading.push(this.codification[0]);
          }
          if (!this.searchTabHeading.some(x => x.toLocaleLowerCase().includes(("Original Pronouncements").toLocaleLowerCase()))) {
            this.searchTabHeading.push(this.originalPronouncements[0]);
          }
          if (!this.searchTabHeading.some(x => x.toLocaleLowerCase().includes(("Comprehensive Implementation Guide").toLocaleLowerCase()))) {
            this.searchTabHeading.push(this.implementationGuide[0]);
          }
        }
      }
    });

  }
  searchComponentRedirection() {
    if (this.searchText.length > 0) {
      this.searchInput.inputText = this.searchText;
      localStorage.setItem("ElasticSearchTerm", this.searchText);
      //this.commonDataService.searchInput.next(this.searchInput);
      //Added condition to prevent addSearchTerm api call for External/Basic view in Leftnav Search - MS-773
      if (this.session.userInfo != null && this.session.userInfo.user.role != null && this.session.userInfo.user.role != "Basic") {
        var searchTerm = { "Id": "-1", "SearchKeyword": this.searchText, "Application": "", "CreateDate": "", "UpdateDate": "", "UpdateUserId": "", "IsActive": true }
        this.httpCall.addSearchTerm(searchTerm).subscribe(data => console.log(data));
      }
            
      this.route.navigateByUrl("/search" + "?query=" + this.searchInput.inputText);
      this.l2State = "out";
      this.btnState = "out";
    }
  }

  category: number = 0;
  onSearchChange(searchValue: string): void {
    this.category = 0;
    if (this.role != "Professional" || searchValue == null || searchValue == "") {
      forkJoin(
        this.graphqlService.getAutoSuggestionsElasticSearch(searchValue),
        this.graphqlService.getTop5CodElasticSearch(searchValue),
        this.graphqlService.getTop5OpElasticSearch(searchValue),
        this.graphqlService.getTop5CigElasticSearch(searchValue)
        // .subscribe(([suggestions, top5Paras, top5Topics, glossaryContent]) => {
      ).subscribe(([suggestions, top5Cod, top5Op, top5Cig]) => {

        this.autoSuggestion = suggestions.suggest.mySuggestion[0].options;
        this.autoSuggestedOptionLength = this.autoSuggestion.length;
        this.top5CodRecords = top5Cod?.hits?.hitsList;
        this.top5OpRecords = top5Op?.hits?.hitsList;
        this.top5CigRecords = top5Cig?.hits?.hitsList;
        this.getGlossaryData(searchValue);

      });
    } else {
      forkJoin(
        this.graphqlService.getAutoSuggestionsElasticSearch(searchValue),
        this.graphqlService.getTop5CodElasticSearch(searchValue),
        this.graphqlService.getTop5OpElasticSearch(searchValue),
        this.graphqlService.getTop5CigElasticSearch(searchValue),
        this.httpCall.getElasticAnnotation(searchValue, "5", ""),
        this.httpCall.getElasticBookmark(searchValue, "5", "")
        // .subscribe(([suggestions, top5Paras, top5Topics, annotations, bookmark, glossaryContent]) => {
      ).subscribe(([suggestions, top5Cod, top5Op, top5Cig, annotations, bookmark]) => {

        this.autoSuggestion = suggestions.suggest.mySuggestion[0].options;
        this.autoSuggestedOptionLength = this.autoSuggestion.length;
        this.top5CodRecords = top5Cod?.hits?.hitsList;
        this.top5OpRecords = top5Op?.hits?.hitsList;
        this.top5CigRecords = top5Cig?.hits?.hitsList;
        // this.numberOfResult = top5Paras.hits.total.value;
        let othercounter = 0;
        let bookmarks = [];
        this.annotationResult = annotations;
        this.bookmarkResult = bookmark;
        if (this.annotationResult.length < 5) {
          othercounter = this.annotationResult.length;
          if (othercounter < 5) {
            this.bookmarkResult.forEach(bookmarkRes => {
              if (bookmarkRes && othercounter < 5) {
                othercounter = othercounter + 1;
                bookmarks.push(bookmarkRes);
              }
            });
          }
          this.bookmarkResult = bookmarks;
        }
        else if (this.annotationResult.length == 5) {
          this.bookmarkResult = [];
        }

        this.getGlossaryData(searchValue);
        if (othercounter > 0) { this.category++ }
      });

    }
  }

  getGlossaryData(searchValue: string) {
    let codCounter = this.top5CodRecords.length;
    this.CodGlossaryResult = [];
    if (codCounter < 5) {
      this.graphqlService.GetMasterGlossarySearch(searchValue, 0, "COD").subscribe(codGlossaryRes => {
        if (codGlossaryRes && codGlossaryRes.hits && codGlossaryRes.hits.hitsList) {
          codGlossaryRes.hits.hitsList.forEach(element => {
            if (element && codCounter < 5) {
              codCounter = codCounter + 1;
              this.CodGlossaryResult.push(element);
            }
          });
        }
      })
    }

    let opCounter = this.top5OpRecords.length;
    this.OpGlossaryResult = [];
    if (opCounter < 5) {
      this.graphqlService.GetMasterGlossarySearch(searchValue, 0, "OP").subscribe(opGlossaryRes => {
        if (opGlossaryRes && opGlossaryRes.hits && opGlossaryRes.hits.hitsList) {
          opGlossaryRes.hits.hitsList.forEach(element => {
            if (element && opCounter < 5) {
              opCounter = opCounter + 1;
              this.OpGlossaryResult.push(element);
            }
          });
        }
      })
    }

    let cigCounter = this.top5CigRecords.length;
    this.CigGlossaryResult = [];
    if (cigCounter < 5) {
      this.graphqlService.GetMasterGlossarySearch(searchValue, 0, "CIG").subscribe(cigGlossaryRes => {
        if (cigGlossaryRes && cigGlossaryRes.hits && cigGlossaryRes.hits.hitsList) {
          cigGlossaryRes.hits.hitsList.forEach(element => {
            if (element && cigCounter < 5) {
              cigCounter = cigCounter + 1;
              this.CigGlossaryResult.push(element);
            }
          });
        }
      })
    }

    if (codCounter > 0) { this.category++ }
    if (opCounter > 0) { this.category++ }
    if (cigCounter > 0) { this.category++ }
  }
  loadLogo() {
    this.graphqlService.getS3BucketImageGARSLogo().subscribe(data => {
      this.logo = this.domSanitizer.bypassSecurityTrustUrl(data);
    });
  }

  highlight: number = undefined;
  loginPageredirect() {
    if (!this.route.url.includes("GARSpdfs")) {
      this.area = "";
      if (localStorage.getItem("ArchiveVersion")) {
        this.navigateToHome();
        return;
      }
      //this.route.navigateByUrl("/Home");
      this.popupRedirect("/Home");
      this.closeNav();
      this.selectedIndexLevel1 = 100;
    }
  }

  navigateToHome() {

    let popUpMessage = constObj.currentVersionNavigationGASBIconAlert;

    localStorage.setItem("isConfirmPopup", "true");
    this.commonDataService.isConfirmationPopUpOpen.next(true);
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      disableClose: true,
      width: '600px',
      data: popUpMessage
    });
    dialogRef.afterClosed().subscribe((result: boolean) => {
      localStorage.removeItem("isConfirmPopup");
      if (result == true) {
        this.commonDataService.resetPrintQueue.next(true);
        this.commonDataService.printCount.next("toggleOff");
        this.commonDataService.printToggleOff.next("printToggleOff");
        localStorage.removeItem("ArchiveVersion");
        this.RedirectionToHomeOnArchiveClick(null);
        this.popupRedirect("/Home");
        this.selectedIndexLevel1 = 100;
      }
    });
  }

  showallinonepagerequiredon3rdlevel: boolean = false;
  showallinonepagerequiredon4thlevel: boolean = false;
  navClicked(obj, index) {
    this.flag = false;
    switch (index) { 
      case 1: {
        //var x = document.getElementsByClassName('navElement');
        //var slides = document.getElementsByClassName('selectedFirstNavElement');
        //for (var i = 0; i < x.length; i++) {
        //  if (x[i].classList.contains('selectedFirstNavElement')) { x[i].classList.remove('selectedFirstNavElement') }
        //}

        //x[this.selectedIndexLevel1 + 1]?.classList.add('selectedFirstNavElement');

        this.l3State = "out";
        this.l4State = "out";
        this.l5State = "out";
        this.selectedIndexLevel2 = undefined;
        this.selectedIndexLevel3 = undefined;
        this.selectedIndexLevel4 = undefined;
        this.selectedIndexLevel5 = undefined;
        this.crumbDataNav = [
          this.tempData[this.selectedIndexLevel1].item
        ]
        if (this.tempData[this.selectedIndexLevel1].itemData.length === 0) {
          this.l2State = "out";
          this.btnState = "out";
         
          if (this.tempData[this.selectedIndexLevel1].item == "My GARS") {

            this.commonDataService.isConfirmationPopUpOpen.next(false);
            this.commonDataService.aaaUserMessage.next(true);
            this.dialog.open(ConfirmDialogComponent, {
              disableClose: true,
              width: '600px',
              data: constObj.aaaFeaturemessage
            });
            return;
          }
          this.urlPath = this.tempData[this.selectedIndexLevel1].itemLink

          if (this.tempData[this.selectedIndexLevel1].itemLink.includes("logout")) {
            //this._loginservice.getlogoutURL(window.location.origin).subscribe(data => {
            //this._loginservice.deleteSession().subscribe();
            //window.location.href = this.getLogoutURL(data);
            //})
            /*
            this.session.assignUserInfo(null);
            this.commonDataService.globalLabels.unsubscribe();
            localStorage.removeItem("isPendingContentPage");
            localStorage.removeItem("PCSIntegratedData");
            localStorage.removeItem("DefaultSecView");
            localStorage.removeItem("ElasticSearchTerm");
            this.location.replaceState('', ''); */ //if click 'no'in popup, this lins will remove before conform msg so add those line inside of popupRedirect();

            this._loginservice.deleteSession().subscribe(data => {
              if (this.role == "Basic") {
                // window.location.href = "Login";
                this.popupRedirect("Login", 1);
              }
              else {
                //window.location.href = "/Login/proViewLogin";
                this.popupRedirect("/Login/proViewLogin", 1);

              }
            });
            return;
          }
          // this.route.navigateByUrl(this.urlPath);
          this.popupRedirect(this.urlPath);
          this.isSearchClicked = false;
          this.originalIndex = this.selectedIndexLevel1;
          this.originalIndex = this.selectedIndexLevel1;
          this.closeNav();
        }
        else {
          //if (this.tempData[this.selectedIndexLevel1].item.includes("Other Reference")) {
          //this.tempData[this.selectedIndexLevel1].itemData.filter(x => x.item.includes("(gasb.org)") ? x.item = x.item.split("(gasb.org)")[0] + "<b class=\"color_red\"> (gasb.org) </b>" : x.item);
          //}
          this.l2State = "in";
          this.btnState = "in";
          setTimeout(() => {
            let nextLevelFirstNode = new ElementRef(this.elemLevel2.nativeElement.childNodes[0].childNodes[0].childNodes[1].childNodes[0]);
            nextLevelFirstNode.nativeElement.focus();
          }, 400);
        }
        break;
      }
      case 2: {
        this.l4State = "out";
        this.l5State = "out";
        this.selectedIndexLevel3 = undefined;
        this.selectedIndexLevel4 = undefined;
        this.selectedIndexLevel5 = undefined;
        if (this.tempData[this.selectedIndexLevel1].item != "Archive") {
          this.crumbData = [
            this.tempData[this.selectedIndexLevel1].item,
            this.tempData[this.selectedIndexLevel1].itemData[this.selectedIndexLevel2].item
          ]
          if (this.tempData[this.selectedIndexLevel1].itemData[this.selectedIndexLevel2].item.includes("(gasb.org)")) {
            window.open(this.tempData[this.selectedIndexLevel1].itemData[this.selectedIndexLevel2].itemLink);
            this.closeNav();
            break;
          }

          this.crumbDataNav = this.crumbData;
          if (this.tempData[this.selectedIndexLevel1].itemData[this.selectedIndexLevel2].itemData.length === 0 || this.tempData[this.selectedIndexLevel1].itemData[this.selectedIndexLevel2].rollUp == 'True') {
            this.l3State = "out";

            this.urlPath = this.tempData[this.selectedIndexLevel1].itemData[this.selectedIndexLevel2].itemLink;

            if (this.crumbData[1] == "My Annotations" || this.crumbData[1] == "Glossary Term Finder" || this.crumbData[1] == "My History") {
              this.commonDataService.EditFromContentPage.next(false);
            }

            if (this.crumbData[1] == "Search") {
              //this.search();
              this.popupRedirect(1, 2);
            }
            else {
              // this.route.navigateByUrl(this.urlPath);
              this.popupRedirect(this.urlPath);
              this.isSearchClicked = false;
              this.originalIndex = this.selectedIndexLevel1;

              this.closeNav();
            }

          } else {
            this.l3State = "in";
            this.showallinonepagerequiredon3rdlevel = true;
            for (let i = 0; i < this.tempData[this.selectedIndexLevel1].itemData[this.selectedIndexLevel2].itemData.length; i++) {
              if (this.tempData[this.selectedIndexLevel1].itemData[this.selectedIndexLevel2].itemData[i].itemData.length > 0 && this.tempData[this.selectedIndexLevel1].itemData[this.selectedIndexLevel2].itemData[i].rollUp == "False") {
                this.showallinonepagerequiredon3rdlevel = false;
                break;
              }
            }

          }
        }
        else {
          let triggerArchiveVersion = this.tempData[this.selectedIndexLevel1].itemData[this.selectedIndexLevel2];
          if (localStorage.getItem("publicationId") != triggerArchiveVersion.itemLink) {
            this.popupRedirectToHomeOnArchiveClick(triggerArchiveVersion);
            this.closeNav();
          } else {
            this.closeNav();
            if (localStorage.getItem("currentVersionPublicationId") == triggerArchiveVersion.itemLink) {
              this.route.navigateByUrl("/Home");
              this.isCurrentLeftNav = true;
            }
          } 
          }
        break;
      }
      case 3: {
        this.l5State = "out";
        this.selectedIndexLevel4 = undefined;
        this.selectedIndexLevel5 = undefined;
        this.crumbData = [
          this.tempData[this.selectedIndexLevel1].item,
          this.tempData[this.selectedIndexLevel1].itemData[this.selectedIndexLevel2].item,
          this.tempData[this.selectedIndexLevel1].itemData[this.selectedIndexLevel2].itemData[this.selectedIndexLevel3].item
        ]
        this.crumbDataNav = this.crumbData;
        if (this.tempData[this.selectedIndexLevel1].itemData[this.selectedIndexLevel2].itemData[this.selectedIndexLevel3].itemData.length === 0 || this.tempData[this.selectedIndexLevel1].itemData[this.selectedIndexLevel2].itemData[this.selectedIndexLevel3].rollUp == 'True') {
          this.l4State = "out";
          this.urlPath = this.tempData[this.selectedIndexLevel1].itemData[this.selectedIndexLevel2].itemData[this.selectedIndexLevel3].itemLink;
          
          // this.route.navigateByUrl(this.urlPath);
          this.popupRedirect(this.urlPath);
          this.isSearchClicked = false;
          this.originalIndex = this.selectedIndexLevel1;
          this.closeNav()
        } else {
          this.l4State = "in";
          this.showallinonepagerequiredon4thlevel = true;
          //setTimeout(() => {
          //  let nextLevelFirstNode = new ElementRef(this.elemLevel4.nativeElement.childNodes[0].childNodes[1].childNodes[0].childNodes[0]);
          //  nextLevelFirstNode.nativeElement.focus();
          //}, 400);

          for (let i = 0; i < this.tempData[this.selectedIndexLevel1].itemData[this.selectedIndexLevel2].itemData[this.selectedIndexLevel3].itemData.length; i++) {
            if (this.tempData[this.selectedIndexLevel1].itemData[this.selectedIndexLevel2].itemData[this.selectedIndexLevel3].itemData[i].itemData.length > 0 && this.tempData[this.selectedIndexLevel1].itemData[this.selectedIndexLevel2].itemData[this.selectedIndexLevel3].itemData[i].rollUp == "False") {
              this.showallinonepagerequiredon4thlevel = false;
              break;
            }
          }

        }
        break;
      }
      case 4: {
        this.selectedIndexLevel5 = undefined;
        this.crumbData = [
          this.tempData[this.selectedIndexLevel1].item,
          this.tempData[this.selectedIndexLevel1].itemData[this.selectedIndexLevel2].item,
          this.tempData[this.selectedIndexLevel1].itemData[this.selectedIndexLevel2].itemData[this.selectedIndexLevel3].item,
          this.tempData[this.selectedIndexLevel1].itemData[this.selectedIndexLevel2].itemData[this.selectedIndexLevel3].itemData[this.selectedIndexLevel4].item
        ]
        this.crumbDataNav = this.crumbData;
        if (this.tempData[this.selectedIndexLevel1].itemData[this.selectedIndexLevel2].itemData[this.selectedIndexLevel3].itemData[this.selectedIndexLevel4].itemData.length === 0 || this.tempData[this.selectedIndexLevel1].itemData[this.selectedIndexLevel2].itemData[this.selectedIndexLevel3].itemData[this.selectedIndexLevel4].rollUp == 'True') {

          this.urlPath = this.tempData[this.selectedIndexLevel1].itemData[this.selectedIndexLevel2].itemData[this.selectedIndexLevel3].itemData[this.selectedIndexLevel4].itemLink;
          
          // this.route.navigateByUrl(this.urlPath);
          this.popupRedirect(this.urlPath);
          this.isSearchClicked = false;
          this.originalIndex = this.selectedIndexLevel1;
          this.closeNav();
        } else {
          this.l5State = "in";

          setTimeout(() => {
            let nextLevelFirstNode = new ElementRef(this.elemLevel4.nativeElement.childNodes[0].childNodes[1].childNodes[0].childNodes[0]);
            nextLevelFirstNode.nativeElement.focus();
          });
        }
        break;
      }
      case 5: {
        this.crumbData = [
          this.tempData[this.selectedIndexLevel1].item,
          this.tempData[this.selectedIndexLevel1].itemData[this.selectedIndexLevel2].item,
          this.tempData[this.selectedIndexLevel1].itemData[this.selectedIndexLevel2].itemData[this.selectedIndexLevel3].item,
          this.tempData[this.selectedIndexLevel1].itemData[this.selectedIndexLevel2].itemData[this.selectedIndexLevel3].itemData[this.selectedIndexLevel4].item,
          this.tempData[this.selectedIndexLevel1].itemData[this.selectedIndexLevel2].itemData[this.selectedIndexLevel3].itemData[this.selectedIndexLevel4].itemData[this.selectedIndexLevel5].item,
        ]
        this.crumbDataNav = this.crumbData;
        
        //if (this.tempData[this.selectedIndexLevel1].itemData[this.selectedIndexLevel2].itemData[this.selectedIndexLevel3].itemData[this.selectedIndexLevel4].itemData[this.selectedIndexLevel5].length == 0) {
        this.urlPath = this.tempData[this.selectedIndexLevel1].itemData[this.selectedIndexLevel2].itemData[this.selectedIndexLevel3].itemData[this.selectedIndexLevel4].itemData[this.selectedIndexLevel5].itemLink;
        // this.route.navigateByUrl(this.urlPath);
        this.popupRedirect(this.urlPath);
        this.isSearchClicked = false;
        //}
        //else {
        //  this.showAllInOnePage(this.tempData[this.selectedIndexLevel1].itemData[this.selectedIndexLevel2].itemData[this.selectedIndexLevel3].itemData[this.selectedIndexLevel4].itemData[this.selectedIndexLevel5]);
        //}
        this.originalIndex = this.selectedIndexLevel1;
        this.closeNav();
        break;
      }
    }
  }

  RedirectionToHomeOnArchiveClick(archivePublicationId) {
    this.outcome = false;
    this.commonDataService.showLoader.next(true);
    if (archivePublicationId !=null && archivePublicationId != localStorage.getItem("currentVersionPublicationId")) {
      this.graphqlService.getArchiveLeftNavigation(archivePublicationId).subscribe(leftNavigationData => {
        localStorage.setItem("publicationId", archivePublicationId);
        this.isCurrentLeftNav = false;
        this.getLeftNavigation(leftNavigationData);
        this.tempData = this.tempData.filter(x => x.item != "My GARS" && x.item != "Search" && x.item != "Other Reference");
        this.tempData[this.tempData.length - 4].spaceOnTop = "true";
        this.tempData[this.tempData.length - 4].itemData = this.tempData[this.tempData.length - 4].itemData.filter(x => x.item != "Search" && x.item != "Source Tracing Tool" && x.item != "Glossary Term Finder");
        this.isArchive = true; this.route.navigateByUrl("/ArchiveHome");
        this.commonDataService.showLoader.next(false);
        this.outcome = true;
      });
    }
    else {
      this.graphqlService.getCurrentVersionLeftNavigation().subscribe(leftNavigationData => {
      //this.graphqlService.getLeftNavigation().subscribe(leftNavigationData => {
        var publicationId = leftNavigationData[1].itemData[0].itemData[0].itemData[0].itemLink.split('/');
        this.isCurrentLeftNav = true;
        localStorage.setItem("currentVersionPublicationId", publicationId[0]);
        localStorage.setItem("publicationId", publicationId[0]);
        this.isArchive = false;
        this.getLeftNavigation(leftNavigationData); this.route.navigateByUrl("/Home");
        this.commonDataService.showLoader.next(false);
        this.outcome = true;
      });
    }
  }

  //showAllInOnePage(obj, level) {
  //  let crumbData: string[] = [];
  //  crumbData.push(this.tempData[this.selectedIndexLevel1].item);
  //  crumbData.push(this.tempData[this.selectedIndexLevel1].itemData[this.selectedIndexLevel2].item);
  //  crumbData.push(this.tempData[this.selectedIndexLevel1].itemData[this.selectedIndexLevel2].itemData[this.selectedIndexLevel3].item);
  //  if (level > 4) {
  //    crumbData.push(this.tempData[this.selectedIndexLevel1].itemData[this.selectedIndexLevel2].itemData[this.selectedIndexLevel3].itemData[this.selectedIndexLevel4].item);
  //  }
  //  localStorage.setItem("ShowAllInOnePage", JSON.stringify({ breadcrumb: crumbData, child: obj }));
  //}

  mainsection: string = "";

  pagepublicationId: { publid: string, pageid: string, pagetitle: string, pageurl: any, pageNavPath: string }[] = [];
  pagepubllist: { sectionarray: any[], sectionname: string, mainsectionname: string }[] = [];
  showAllInOnePage(obj) {
    this.commonDataService.selectednavindex.next(this.selectedIndexLevel1);
    this.pagepublicationId = [];
    this.pagepubllist = [];
    this.mainsection = this.tempData[this.selectedIndexLevel1].itemData[this.selectedIndexLevel2].item;
    this.getpagepublids(obj);
    if (this.pagepublicationId.length > 0) {
      this.pagepubllist.push({ sectionarray: this.pagepublicationId, sectionname: obj.item, mainsectionname: this.mainsection });
      this.pagepublicationId = [];
    }
    localStorage.setItem("publpageId", JSON.stringify(this.pagepubllist));
   
    let navPath: string[] = this.pagepubllist[0].sectionarray[0].pageNavPath?.split("-");
    navPath.pop();
    let navPathString: string = navPath.join("/");
    let url = navPathString + '/showallinonepage';
    //this.route.navigateByUrl(url);
    this.popupRedirect(url);
    this.closeNav();

  }
  /* Start -- Annonation pop-up for print queue with MS -299 */
  popupRedirect(url, x?) {
    if (x == 2) { this.closeNav(); }
    const PrintQueueSession = localStorage.getItem("SetPrintQueueSession");
    var printQueueCount: any = PrintQueueSession == "{}" ? 0 : PrintQueueSession == null ? 0 : PrintQueueSession == "" ? 0 : JSON.parse(localStorage.getItem("SetPrintQueueSession")).ParagraphIdsList.length;
    if (printQueueCount > 0) {
      localStorage.setItem("isConfirmPopup", "true");
      this.commonDataService.isConfirmationPopUpOpen.next(true);
      const dialogRef = this.dialog.open(ConfirmDialogComponent, {
        disableClose: true,
        width: '600px',
        data: constObj.annotationAlertPrintQueue
      });
      dialogRef.afterClosed().subscribe((result: boolean) => {
        localStorage.removeItem("isConfirmPopup");
        if (result == true) {
          this.commonDataService.resetPrintQueue.next(true);
          this.commonDataService.printCount.next("toggleOff");
          this.commonDataService.printToggleOff.next("printToggleOff");
          if (x == 1) {
            this.session.assignUserInfo(null);
            this.commonDataService.globalLabels.unsubscribe();
            localStorage.removeItem("DefaultSecView");
            localStorage.removeItem("ElasticSearchTerm");
            this.location.replaceState('', '');
            window.location.href = url;
          } else {
            x == 2 ? this.search() : this.route.navigateByUrl(url);
          }
        }
      });
    } else {
      if (x == 1) {
        this.session.assignUserInfo(null);
        this.commonDataService.globalLabels.unsubscribe();
        localStorage.removeItem("DefaultSecView");
        localStorage.removeItem("ElasticSearchTerm");
        this.location.replaceState('', '');
        window.location.href = url;
      } else {
        x == 2 ? this.search() : this.route.navigateByUrl(url);
      }

    }
  }

  popupRedirectToHomeOnArchiveClick(archiveVersion) {
    const PrintQueueSession = localStorage.getItem("SetPrintQueueSession");
    var printQueueCount: any = PrintQueueSession == "{}" ? 0 : PrintQueueSession == null ? 0 : PrintQueueSession == "" ? 0 : JSON.parse(localStorage.getItem("SetPrintQueueSession")).ParagraphIdsList.length;
    let popUpMessage = constObj.archiveVersionNavigationAlert + archiveVersion.item+ ".";
    if (printQueueCount > 0) {
      popUpMessage += "<br/>" + constObj.annotationAlertPrintQueue;
    }
    else { popUpMessage += "<br/>" + constObj.continueMessage; }
    let triggerArchiveVersion = this.tempData[this.selectedIndexLevel1].itemData[this.selectedIndexLevel2];
    if (localStorage.getItem("ArchiveVersion") == triggerArchiveVersion.item) {
      return;
    }
    localStorage.setItem("isConfirmPopup", "true");
    this.commonDataService.isConfirmationPopUpOpen.next(true);
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      disableClose: true,
      width: '600px',
      data: popUpMessage
    });
    dialogRef.afterClosed().subscribe((result: boolean) => {
      localStorage.removeItem("isConfirmPopup");
      if (result == true) {
        this.commonDataService.resetPrintQueue.next(true);
        this.commonDataService.printCount.next("toggleOff");
        this.commonDataService.printToggleOff.next("printToggleOff");
        localStorage.setItem("ArchiveVersion", archiveVersion.item);
        this.RedirectionToHomeOnArchiveClick(archiveVersion.itemLink);
      }
    });
    //} else {
    //  this.RedirectionToHomeOnArchiveClick(archiveVersion.itemLink);
    //}
  }

  /* End -- Annonation pop-up for print queue with MS -299 */
  getpagepublids(obj) {
    //if (obj.itemData.length > 0 && obj.rollUp != 'True') {
    //  for (let items of obj.itemData) {
    //    this.getpagepublids(items);
    //  }
    //}
    //if ((obj.itemData.length == 0 || obj.rollUp == 'True') && obj.itemLink != null) {
    //  if (obj.itemLink != null) {
    //    let PublpageId = obj.itemLink.split('/').map(d => d);
    //    let pageTitle = obj.item;
    //    this.pagepublicationId.push({ publid: PublpageId[0], pageid: PublpageId[1], pagetitle: pageTitle, pageurl: obj.itemLink, pageNavPath: obj.navPath });
    //  }
    //}
    if (obj.itemData.length > 0 && obj.rollUp != 'True') {
      for (let items of obj.itemData) {
        this.getpagepublids(items);
      }
    }
    if (obj.itemLink != null && (obj.itemData?.length == 0 || obj.rollUp == 'True')) {
      let PublpageId = obj.itemLink.split('/').map(d => d);
      let pageTitle = obj.item;
      this.pagepublicationId.push({ publid: PublpageId[0], pageid: PublpageId[1], pagetitle: pageTitle, pageurl: obj.itemLink, pageNavPath: obj.navPath });
    }
    else {
      if (this.pagepublicationId.length > 0) {
        this.pagepubllist.push({ sectionarray: this.pagepublicationId, sectionname: obj.item, mainsectionname: this.mainsection });
        this.pagepublicationId = [];
      }
    }
  }


  closeNav() {
    this.l2State = "out";
    this.l3State = "out";
    this.l4State = "out";
    this.l5State = "out";
    this.btnState = "out";
    this.selectedIndexLevel2 = undefined;
    this.selectedIndexLevel3 = undefined;
    this.selectedIndexLevel4 = undefined;
    this.selectedIndexLevel5 = undefined;
    this.highlight = undefined;
    this.menuOpen = false;
    this.selectedIndexLevel1 = this.originalIndex;
    this.searchText = "";
    this.searchInput.inputText = "";
    if (!this.route.url?.includes("search")) {
      this.isSearchClicked = false;
    }
  }

  animationDone(state1, index) {
    if (state1 === "out") {
      this.menuIndexNegativeArr[index] = true;
    }
  }

  animationStart(state1, index) {
    if (state1 === "in") {
      this.menuIndexNegativeArr[index] = false;
    }
  }
  //getLogoutURL(data) {
  //  this.logoutURL = data.logoutRedirectURL;
  //  return this.logoutURL;
  //}

  nextTab(event) {
    if (event.srcElement.nextSibling) {
      let next = new ElementRef(event.srcElement.nextSibling);
      next.nativeElement.focus();
    }
  }

  previousTab(event) {
    if (event.srcElement.previousSibling) {
      let previous = new ElementRef(event.srcElement.previousSibling);
      previous.nativeElement.focus();
    }
  }

  nextLevel(index) {
    switch (index) {
      case 1: {
        if (this.l2State === "in") {
          let nextLevelFirstNode = new ElementRef(this.elemLevel2.nativeElement.childNodes[0].childNodes[0].childNodes[1].childNodes[0]);
          nextLevelFirstNode.nativeElement.focus();
        }
        break;
      }
      case 2: {
        if (this.l3State === "in") {
          let nextLevelFirstNode = new ElementRef(this.elemLevel3.nativeElement.childNodes[0].childNodes[0].childNodes[1].childNodes[0]);
          nextLevelFirstNode.nativeElement.focus();
        }
        break;
      }
      case 3: {
        if (this.l4State === "in") {
          let nextLevelFirstNode = new ElementRef(this.elemLevel4.nativeElement.childNodes[0].childNodes[0].childNodes[1].childNodes[0]);
          nextLevelFirstNode.nativeElement.focus();
        }
        break;
      }
      case 4: {
        if (this.l5State === "in") {
          let nextLevelFirstNode = new ElementRef(this.elemLevel5.nativeElement.childNodes[0].childNodes[0].childNodes[1].childNodes[0]);
          nextLevelFirstNode.nativeElement.focus();
        }
        break;
      }
    }
  }

  previousLevel(index) {
    switch (index) {
      case 2: {
        let nextLevelFirstNode = new ElementRef(this.elemLevel1.nativeElement.childNodes[0]);
        nextLevelFirstNode.nativeElement.focus();
        break;
      }
      case 3: {
        let nextLevelFirstNode = new ElementRef(this.elemLevel2.nativeElement.childNodes[0].childNodes[0].childNodes[1].childNodes[0]);
        nextLevelFirstNode.nativeElement.focus();
        break;
      }
      case 4: {
        let nextLevelFirstNode = new ElementRef(this.elemLevel3.nativeElement.childNodes[0].childNodes[0].childNodes[1].childNodes[0]);
        nextLevelFirstNode.nativeElement.focus();
        break;
      }
      case 5: {
        let nextLevelFirstNode = new ElementRef(this.elemLevel4.nativeElement.childNodes[0].childNodes[0].childNodes[1].childNodes[0]);
        nextLevelFirstNode.nativeElement.focus();
        break;
      }
    }
  }

  tabOnClose(event) {
    console.log(event);
  }


  area: string = "";
  getBreadcrumbWithRouteUrl(breadcerumbUrl) {
    this.area = "";
    for (let i = 0; i < this.tempData.length; i++) {
      if (this.tempData != null && this.tempData[i].itemData != null) {
        for (let j = 0; j < this.tempData[i].itemData.length; j++) {
          if (this.tempData[i]?.itemData[j]?.itemLink?.includes(breadcerumbUrl)) {
            this.area = this.tempData[i].item;
            return;
          }
          else {
            if (this.tempData[i].itemData[j].itemData != null) {
              for (let k = 0; k < this.tempData[i].itemData[j].itemData.length; k++) {
                if (this.tempData[i].itemData[j].itemData[k]?.itemLink?.includes(breadcerumbUrl)) {
                  this.area = this.tempData[i].item;
                  return;
                }
                else {
                  if (this.tempData[i].itemData[j].itemData[k].itemData != null) {
                    for (let l = 0; l < this.tempData[i].itemData[j].itemData[k].itemData.length; l++) {
                      if (this.tempData[i].itemData[j].itemData[k].itemData[l]?.itemLink?.includes(breadcerumbUrl)) {
                        this.area = this.tempData[i].item;
                        return;
                      }
                      else {
                        if (this.tempData[i].itemData[j].itemData[k].itemData[l].itemData != null) {
                          for (let m = 0; m < this.tempData[i].itemData[j].itemData[k].itemData[l].itemData.length; m++) {
                            if (this.tempData[i].itemData[j].itemData[k].itemData[l].itemData[m]?.itemLink?.includes(breadcerumbUrl)) {
                              this.area = this.tempData[i].item;
                              return;
                            }
                          }
                        }
                      }
                    }
                  }

                }
              }
            }
          }
        }
      }
    }
    return [];
  }

  getBreadcrumbForNav(breadcerumbUrl) {
    this.area = "";
    for (let i = 0; i < 4; i++) {
      if (this.tempData[i].navPath == breadcerumbUrl) {
        this.area = this.tempData[i].item;
        return;
      }
    }
    return [];
  }
}
